import addParameterHelper from "./add-parameter-helper";

export default function addParameter(url, key, value) {
    return addParameterHelper(url, key + '=' + value);
}